import { IKnmPmFormAct } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormAct';

import styles from './PmActItem.module.scss';

interface IPmActItemProps {
  act: IKnmPmFormAct;
}

export const PmActItemStatus = ({ act }: IPmActItemProps) => {
  if (act.paperless && act.isNew) return <div className={styles.ActStatus}>Черновик</div>;

  if (act.paperless && act.fileInvalidate) return <div className={styles.ActStatusCanceled}>Отменено</div>;

  return null;
};
